import { c as _c } from "react/compiler-runtime";
import { useWatch } from 'react-hook-form';
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { SelectField } from '@module/mdrt-org/shared/components/select-field/select-field';
import { MAX_ADDRESS_LINE_LENGTH, MAX_CITY_LENGTH, MAX_ZIP_CODE_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { CountryId } from '@module/mdrt-org/shared/utils/enums/country-id';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { type SelectOption } from '@shared/utils/types/select-option';
import { useAccountSettingsPageContext } from '../../providers/account-settings-page-context';
import { type ContactInformationFormData, type ContactInformationPhoneNumberFormDataPartial } from '../../utils/types/form-data';
import { type AccountSettingsContactInformationContent } from './get-account-settings-contact-information-content';
import styles from './contact-information-form.module.scss';
const PARENT_CLASSNAME = 'contact-information-form';
export const LocalAddressSection = t0 => {
  const $ = _c(61);
  const {
    cmsContent,
    countryOptions,
    customerProfileCountryId
  } = t0;
  const {
    countriesData,
    localAddressStateOptions
  } = useAccountSettingsPageContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: ["localAddressCountry", "localAddressLineOne", "localAddressCityOrTown", "localAddressStateOrProvinceId", "localAddressZipCode"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [watchLocalAddressCountry, watchLocalAddressLineOne, watchLocalAddressCityOrTown, watchLocalAddressStateOrProvinceId, watchLocalAddressZipCode] = useWatch(t1);
  const selectedLocalAddressCountryId = watchLocalAddressCountry?.value as number;
  let t2;
  if ($[1] !== countriesData || $[2] !== selectedLocalAddressCountryId) {
    let t3;
    if ($[4] !== selectedLocalAddressCountryId) {
      t3 = country => country.countryId === selectedLocalAddressCountryId;
      $[4] = selectedLocalAddressCountryId;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = countriesData.find(t3);
    $[1] = countriesData;
    $[2] = selectedLocalAddressCountryId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedLocalAddressCountry = t2;
  const isLocalAddressFieldFilled = Boolean(watchLocalAddressLineOne || watchLocalAddressCityOrTown || watchLocalAddressStateOrProvinceId || watchLocalAddressZipCode);
  const t3 = isLocalAddressFieldFilled || customerProfileCountryId === CountryId.Japan || customerProfileCountryId === CountryId.China;
  let t4;
  if ($[6] !== cmsContent.requiredLabel || $[7] !== customerProfileCountryId || $[8] !== isLocalAddressFieldFilled) {
    t4 = {
      validate: {
        required: value => {
          if (!value && (isLocalAddressFieldFilled || customerProfileCountryId === CountryId.Japan || customerProfileCountryId === CountryId.China)) {
            return cmsContent.requiredLabel;
          }
          return true;
        }
      }
    };
    $[6] = cmsContent.requiredLabel;
    $[7] = customerProfileCountryId;
    $[8] = isLocalAddressFieldFilled;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = {
      isRequired: t3,
      rules: t4
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const sharedLocalAddressFieldProps = t5;
  let t6;
  if ($[13] !== cmsContent.localLanguageAddressTitleLabel) {
    t6 = <h2 className={styles[`${PARENT_CLASSNAME}__heading`]}>{cmsContent.localLanguageAddressTitleLabel}</h2>;
    $[13] = cmsContent.localLanguageAddressTitleLabel;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== cmsContent.countryLabel || $[16] !== countryOptions) {
    t7 = <SelectField isClearable={true} isDisabled={true} isSearchable={true} label={cmsContent.countryLabel} name="localAddressCountry" options={countryOptions} />;
    $[15] = cmsContent.countryLabel;
    $[16] = countryOptions;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FormInput maxLength={MAX_ADDRESS_LINE_LENGTH} />;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== cmsContent.addressLine1Label || $[20] !== sharedLocalAddressFieldProps) {
    t9 = <FieldController label={cmsContent.addressLine1Label} name="localAddressLineOne" {...sharedLocalAddressFieldProps}>{t8}</FieldController>;
    $[19] = cmsContent.addressLine1Label;
    $[20] = sharedLocalAddressFieldProps;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FormInput maxLength={MAX_ADDRESS_LINE_LENGTH} />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== cmsContent.addressLine2Label) {
    t11 = <FieldController label={cmsContent.addressLine2Label} name="localAddressLineTwo">{t10}</FieldController>;
    $[23] = cmsContent.addressLine2Label;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FormInput maxLength={MAX_ADDRESS_LINE_LENGTH} />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== cmsContent.addressLine3Label) {
    t13 = <FieldController label={cmsContent.addressLine3Label} name="localAddressLineThree">{t12}</FieldController>;
    $[26] = cmsContent.addressLine3Label;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FormInput maxLength={MAX_CITY_LENGTH} />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== cmsContent.cityLabel || $[30] !== sharedLocalAddressFieldProps) {
    t15 = <FieldController label={cmsContent.cityLabel} name="localAddressCityOrTown" {...sharedLocalAddressFieldProps}>{t14}</FieldController>;
    $[29] = cmsContent.cityLabel;
    $[30] = sharedLocalAddressFieldProps;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = isLocalAddressFieldFilled && selectedLocalAddressCountry?.stateProvinceIsRequired || customerProfileCountryId === CountryId.Japan || customerProfileCountryId === CountryId.China;
  let t17;
  if ($[32] !== cmsContent.requiredLabel || $[33] !== customerProfileCountryId || $[34] !== isLocalAddressFieldFilled || $[35] !== selectedLocalAddressCountry?.stateProvinceIsRequired) {
    t17 = {
      validate: {
        required: value_0 => !value_0 && isLocalAddressFieldFilled && selectedLocalAddressCountry?.stateProvinceIsRequired || !value_0 && (customerProfileCountryId === CountryId.Japan || customerProfileCountryId === CountryId.China) ? cmsContent.requiredLabel : true
      }
    };
    $[32] = cmsContent.requiredLabel;
    $[33] = customerProfileCountryId;
    $[34] = isLocalAddressFieldFilled;
    $[35] = selectedLocalAddressCountry?.stateProvinceIsRequired;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== cmsContent.stateProvinceLabel || $[38] !== localAddressStateOptions || $[39] !== t16 || $[40] !== t17) {
    t18 = <SelectField isClearable={true} isRequired={t16} isSearchable={true} label={cmsContent.stateProvinceLabel} name="localAddressStateOrProvinceId" options={localAddressStateOptions} rules={t17} />;
    $[37] = cmsContent.stateProvinceLabel;
    $[38] = localAddressStateOptions;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = isLocalAddressFieldFilled && selectedLocalAddressCountry?.postalCodeIsRequired || selectedLocalAddressCountry?.countryId === CountryId.Japan || selectedLocalAddressCountry?.countryId === CountryId.China;
  let t20;
  if ($[42] !== cmsContent.requiredLabel || $[43] !== isLocalAddressFieldFilled || $[44] !== selectedLocalAddressCountry?.countryId || $[45] !== selectedLocalAddressCountry?.postalCodeIsRequired) {
    t20 = {
      validate: {
        required: value_1 => !value_1 && (selectedLocalAddressCountry?.countryId === CountryId.Japan || selectedLocalAddressCountry?.countryId === CountryId.China || isLocalAddressFieldFilled && selectedLocalAddressCountry?.postalCodeIsRequired) ? cmsContent.requiredLabel : true
      }
    };
    $[42] = cmsContent.requiredLabel;
    $[43] = isLocalAddressFieldFilled;
    $[44] = selectedLocalAddressCountry?.countryId;
    $[45] = selectedLocalAddressCountry?.postalCodeIsRequired;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <FormInput maxLength={MAX_ZIP_CODE_LENGTH} />;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== cmsContent.postalCodeLabel || $[49] !== t19 || $[50] !== t20) {
    t22 = <FieldController isRequired={t19} label={cmsContent.postalCodeLabel} name="localAddressZipCode" rules={t20}>{t21}</FieldController>;
    $[48] = cmsContent.postalCodeLabel;
    $[49] = t19;
    $[50] = t20;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t11 || $[53] !== t13 || $[54] !== t15 || $[55] !== t18 || $[56] !== t22 || $[57] !== t6 || $[58] !== t7 || $[59] !== t9) {
    t23 = <>{t6}{t7}{t9}{t11}{t13}{t15}{t18}{t22}</>;
    $[52] = t11;
    $[53] = t13;
    $[54] = t15;
    $[55] = t18;
    $[56] = t22;
    $[57] = t6;
    $[58] = t7;
    $[59] = t9;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  return t23;
};